/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  FormControl,
  CircularProgress
} from '@mui/material';
import api from '../../services/api';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { pt } from 'yup-locale-pt';
import { Autocomplete, TextField } from '../../components';
import { useStoreState, useStoreActions } from 'easy-peasy';

yup.setLocale(pt);

const DialogoCNAE = ({ atividades, open, onClose, cnae }) => {
  let loading = useStoreState(state => state.nav.loading);
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);

  const schema = yup
    .object({
      codigo: yup.string().label('Código').required(),
      descr: yup.string().label('Descrição').required(),
      atividade_principal_id: yup
        .number()
        .label('Atividade Principal')
        .required()
    })
    .required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const {
    handleSubmit,
    reset,
    formState: { isDirty, isSubmitting }
  } = useFormRef;

  const onSave = async data => {
    startLoading();
    try {
      if (data.id) {
        await api.http.put('/cnaes/' + data.id, data);
      } else {
        await api.http.post('/cnaes', data);
      }
      stopLoading({ severity: 'success' });
      close(true);
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    }
  };

  const close = (reload = false) => {
    reset({
      codigo: '',
      descr: ''
    });
    onClose(reload);
  };

  React.useEffect(() => {
    reset(cnae);
  }, [cnae]);

  return (
    <Dialog open={open} onClose={() => close()}>
      <DialogTitle>Dados do CNAE</DialogTitle>
      <DialogContent>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField
            autoFocus
            margin="dense"
            fullWidth
            field="codigo"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField
            margin="dense"
            fullWidth
            field="descr"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
        <FormControl sx={{ my: 2 }} fullWidth>
          <Autocomplete
            field="atividade_principal_id"
            useFormRef={useFormRef}
            options={atividades}
            getOptionLabel={atividade => atividade.descr}
            schema={schema}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        {loading > 0 && (
          <CircularProgress
            size={30}
            sx={{ position: 'absolute', left: 25, bottom: 12 }}
          />
        )}
        <Button color="inherit" onClick={() => close()}>
          CANCELAR
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit(onSave)}
          disabled={!isDirty || isSubmitting}
        >
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogoCNAE;
